module.exports = __webpack_public_path__ + "static/media/info.f947a7b2.svg";